/**
 * Marketing Studio — Resume chip + last-visited recorder.
 * Phase 1 · Marketing breadcrumb rollout (paco-approved), mirrors
 * BrandStudioResumeChip. The chip is not mounted during the phase-gate;
 * this module exists so the Pillars breadcrumb can record the last-visited
 * Marketing leaf for a future "Resume where you left off" chip on the
 * Marketing Studio landing.
 */
const STORAGE_KEY = "marketing_studio_last_visited";

export function recordMarketingLastVisited(pathname, pillarId, childId) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ pathname, pillarId, childId, ts: Date.now() })
    );
  } catch {
    /* localStorage unavailable — non-fatal */
  }
}

export function getMarketingLastVisited() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
